export default __webpack_public_path__ + "static/media/naidi-3-4.f41d1010.svg";